import { useState, useEffect } from "react";
import RingLoader from "react-spinners/RingLoader";

const Loader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000); // fake API call
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <RingLoader

        color="#dc3545"
        loading={loading}
        size={100}
      />
    </div>
  );
};

export default Loader;
